/** Keeps only the digits of an input (pasted spaces or dashes in a code), up to `max`. */
export const digitsOnly = (raw: string, max: number): string =>
  raw.replace(/\D/g, '').slice(0, max);
